import angular from 'angular';
import relatedEntities from './relatedEntities';
import './style.scss';

export default angular
  .module('components.relatedEntities', [])
  .component('relatedEntities', relatedEntities).name;
